import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import supabase from '../supabase/supabase';

const ADMIN_ID = '5ca0e6e1-8cdb-4a6f-89bd-c1846feab27b';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error: signInError } = await supabase.auth.signInWithPassword({ email, password });
      if (signInError) throw signInError;
      
      if (data.session?.user?.id === ADMIN_ID) {
        navigate('/admin');
      } else {
        // Force sign out if not admin
        await supabase.auth.signOut();
        throw new Error("Access restricted to administrators only.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-retro-teal p-4">
      <div className="bg-retro-cream p-10 rounded-3xl shadow-retro border-4 border-retro-brown w-full max-w-md text-center">
        
        <div className="inline-block bg-retro-yellow border-4 border-retro-brown px-6 py-2 rounded-full shadow-retro mb-8 -rotate-3">
          <h1 className="font-display text-4xl text-retro-brown tracking-wider uppercase">ADMIN LOGIN</h1>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5 text-left">
          <div>
            <label className="block font-bold text-retro-brown mb-2 text-lg">Admin Email</label>
            <input 
              type="email" 
              placeholder="admin@yoopost.com" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              className="w-full p-4 bg-white border-4 border-retro-brown rounded-xl focus:outline-none focus:ring-4 focus:ring-retro-blue font-bold text-retro-brown shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]"
              required 
            />
          </div>
          <div>
            <label className="block font-bold text-retro-brown mb-2 text-lg">Password</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              className="w-full p-4 bg-white border-4 border-retro-brown rounded-xl focus:outline-none focus:ring-4 focus:ring-retro-blue font-bold text-retro-brown shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]"
              required 
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading} 
            className="w-full bg-retro-lime text-retro-brown py-4 rounded-xl font-display text-2xl tracking-wider border-4 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-1 active:translate-y-1 active:shadow-retro-active transition-all mt-4"
          >
            {loading ? 'LOGGING IN...' : 'ENTER VAULT'}
          </button>
        </form>

        {error && (
          <div className="mt-6 bg-white border-4 border-red-500 p-3 rounded-xl shadow-retro-sm">
            <p className="text-base text-red-600 font-bold">{error}</p>
          </div>
        )}

        <p className="mt-8 text-lg font-bold text-retro-brown">
          <Link to="/" className="text-retro-blue underline decoration-4 underline-offset-4 hover:text-retro-teal transition-colors">Back to Home</Link>
        </p>
      </div>
    </div>
  );
}